import React from 'react';
import { motion } from 'framer-motion';
import { assets } from '../../data/assets';
import { SplitText } from '../SplitText';
export function Hero() {
  return <section id="top" className="relative h-[100svh] min-h-[36rem] w-full overflow-hidden bg-black text-white" data-id="element-121" data-mp="7yl0t0z4go5m">
      <video className="absolute inset-0 h-full w-full object-cover" autoPlay muted loop playsInline poster={assets.heroPoster} aria-hidden="true" data-id="element-122" data-mp="huxuhyuo320d">
        <source src={assets.heroVideo} type="video/webm" data-id="element-123" data-mp="qvdv90k0zv1j" />
      </video>
      <div aria-hidden="true" className="absolute inset-0 bg-black/20" data-id="element-124" data-mp="qt9g1mgof9ly" />
      {/* Bottom scrim from the original CSS keeps the headline legible over the video */}
      <div aria-hidden="true" className="absolute inset-0" style={{
      backgroundImage: 'linear-gradient(0deg, #000, rgba(0,0,0,0) 59%)'
    }} data-id="element-125" data-mp="10k450ylb4nb3" />

      <div className="relative z-10 flex h-full flex-col justify-end px-5 pb-[5rem] md:px-10 md:pb-[7.5rem] lg:pb-[10rem]" data-id="element-126" data-mp="1aj3f8llq0r07">
        <div className="mx-auto w-full max-w-[71.875rem]" data-id="element-127" data-mp="9olywcsi04oy">
          <div className="flex max-w-[57rem] flex-col gap-6 lg:gap-[2.5rem]" data-id="element-128" data-mp="4ozla28rcmfm">
            <SplitText as="h1" variant="header" delay={0.45} text="The Design Agency for Smart Brands & Startups" className="text-[3.0625rem] font-medium leading-[1.2] tracking-[-0.015em] sm:text-[4.375rem] lg:text-[5rem] lg:leading-[1.25]" data-id="element-129" data-mp="4r2lff3mjvy2" />
            <motion.p initial={{
            opacity: 0,
            y: 12
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 1.1,
            ease: [0.23, 1, 0.32, 1]
          }} className="text-[1.25rem] font-normal leading-[1.4] tracking-[0.005em] md:text-[1.5625rem]" data-id="element-130" data-mp="nfh7dnz34js0">
              We specialize in UX/UI Design, Websites and Brand Identity Design.
            </motion.p>
          </div>
        </div>
      </div>
    </section>;
}